/* PRDGY quick-add orphan scroll-lock recovery v1 — DAWN SEO duplicate theme.
   Passive/event-based only. Does not close GoKwik/Kwikpass/Kwik Cart or checkout UI. */
(function () {
  if (window.__PRDGY_QUICKADD_RECOVERY_V1__) return;
  window.__PRDGY_QUICKADD_RECOVERY_V1__ = true;

  var DEBUG = /[?&]prdgy_debug=1\b/.test(location.search);
  var scheduled = 0;
  var lastUserSignal = 0;

  function log() {
    if (!DEBUG || !window.console) return;
    console.log.apply(console, ['[PRDGY quickadd recovery]'].concat([].slice.call(arguments)));
  }

  function qsa(root, selector) {
    try { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
    catch (_) { return []; }
  }

  function isVisible(el) {
    if (!el) return false;
    var style;
    try { style = window.getComputedStyle(el); } catch (_) { return false; }
    if (!style || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    var rect;
    try { rect = el.getBoundingClientRect(); } catch (_) { return false; }
    return rect.width > 1 && rect.height > 1 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function anyVisible(selector, root) {
    return qsa(root || document, selector).some(isVisible);
  }

  function kwikApiSaysOpen() {
    try {
      if (window.KWIK && window.KWIK.cart) {
        if (typeof window.KWIK.cart.isOpen === 'function' && window.KWIK.cart.isOpen()) return true;
        if (window.KWIK.cart.isOpen === true || window.KWIK.cart.open === true) return true;
      }
    } catch (_) {}
    return false;
  }

  function kwikShadowCartVisible() {
    if (kwikApiSaysOpen()) return true;
    var hosts = qsa(document, 'shadow-dom-container, kwik-cart, gokwik-cart, [id*="kwik"], [class*="kwik"]');
    for (var i = 0; i < hosts.length; i += 1) {
      var root = hosts[i].shadowRoot;
      if (!root) continue;
      var nodes = qsa(root, '.sidecart, .overlay, [class*="sidecart"], [class*="drawer"], [class*="overlay"]');
      for (var j = 0; j < nodes.length; j += 1) {
        if (isVisible(nodes[j])) return true;
      }
    }
    return false;
  }

  function realDawnModalVisible() {
    return anyVisible('quick-add-modal[open], modal-dialog[open], .quick-add-modal[open], .modal[open], details[open] .modal, .product-popup-modal[open]');
  }

  function realCartDrawerVisible() {
    return anyVisible('cart-drawer.active, cart-drawer[open], #CartDrawer.active, .cart-drawer.active, .drawer.active, .drawer[open], .cart-notification.active');
  }

  function kwikpassOrCheckoutVisible() {
    if (anyVisible('iframe#iframe-kp, iframe[src*="kwik"], iframe[src*="gokwik"], iframe[src*="checkout"], iframe[src*="razorpay"]')) return true;
    return anyVisible('[class*="kwikpass"], [id*="kwikpass"], [class*="gokwik"], [id*="gokwik"]');
  }

  function realUiIsOpen() {
    return realDawnModalVisible() || realCartDrawerVisible() || kwikShadowCartVisible() || kwikpassOrCheckoutVisible();
  }

  function bodyLooksLocked() {
    var body = document.body;
    var html = document.documentElement;
    if (!body) return false;
    var bs = window.getComputedStyle(body);
    var hs = window.getComputedStyle(html);
    return body.classList.contains('overflow-hidden') ||
      html.classList.contains('overflow-hidden') ||
      body.style.overflow === 'hidden' ||
      body.style.overflowY === 'hidden' ||
      html.style.overflow === 'hidden' ||
      html.style.overflowY === 'hidden' ||
      bs.overflow === 'hidden' ||
      bs.overflowY === 'hidden' ||
      hs.overflow === 'hidden' ||
      hs.overflowY === 'hidden';
  }

  function unlockOrphan(reason) {
    var body = document.body;
    var html = document.documentElement;
    if (!body || !bodyLooksLocked()) return;
    if (realUiIsOpen()) {
      log('lock kept; real UI visible', reason);
      return;
    }

    body.classList.remove('overflow-hidden');
    html.classList.remove('overflow-hidden');

    if (body.style.overflow === 'hidden' || body.style.overflowY === 'hidden') {
      body.style.overflow = '';
      body.style.overflowY = '';
    }
    if (html.style.overflow === 'hidden' || html.style.overflowY === 'hidden') {
      html.style.overflow = '';
      html.style.overflowY = '';
    }

    // Dawn/third-party orphan locks sometimes leave fixed positioning without an open modal.
    if (body.style.position === 'fixed') {
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
    }

    log('orphan lock cleared', reason);
    try { window.dispatchEvent(new CustomEvent('prdgy:quickadd:orphan-lock-cleared', { detail: { reason: reason } })); } catch (_) {}
  }

  function schedule(reason, delay) {
    clearTimeout(scheduled);
    scheduled = setTimeout(function () { unlockOrphan(reason); }, delay || 260);
  }

  function userSignal(reason) {
    lastUserSignal = Date.now();
    schedule(reason, 360);
  }

  ['pageshow', 'popstate', 'focus'].forEach(function (eventName) {
    window.addEventListener(eventName, function () { schedule(eventName, 320); }, { passive: true });
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) schedule('visibilitychange', 420);
  }, { passive: true });

  ['click', 'touchstart', 'pointerdown'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      if (Date.now() - lastUserSignal < 250) return;
      userSignal(eventName);
    }, { passive: true, capture: true });
  });

  window.addEventListener('prdgy:collection:loaded', function () { schedule('collection-loaded', 500); }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule('DOMContentLoaded', 500); }, { once: true });
  } else {
    schedule('initial', 500);
  }
})();
